/* istanbul ignore file */
/* eslint-disable import/prefer-default-export */
export const AUTH_EVENTS = {
  USER_REGISTRATION: 'UserRegistration',
  USER_LOGIN: 'UserLogin',
  USER_LOGOUT: 'UserLogout',
  USER_LEAVE: 'UserLeave',
};
